<template>
  <page>
    <coupon :coupon-info="couponInfo"></coupon>
    <div class="content">
      <div class="title">
        <div class="title-text">今日任务</div>
        <div class="title-btn" @click="goRecord">反馈记录</div>
      </div>
      <div class="task-list">
        <task-item
          v-for="(item, index) in taskList"
          :key="index"
          :item="item"
        ></task-item>
        <empty
          v-if="!taskList.length"
          class="empty"
          desc="暂无任务"
          img="Empty"
        ></empty>
      </div>
    </div>
  </page>
</template>

<script>
import { navBar } from '@/utils/native_interactions/native_bar'
import coupon from './components/coupon'
import taskItem from './components/taskItem'
import Empty from '@/common/layout/empty/index'
import { API } from '@/api'
import { companyId, cityId, deviceToken } from '@/defines/user'

export default {
  name: 'MarketResearch',
  components: {
    coupon,
    taskItem,
    Empty
  },
  beforeRouteEnter(to, form, next) {
    next(vm => {
      navBar.setTitle({
        text: '反馈有奖'
      })
    })
  },
  data() {
    return {
      taskList: [],
      couponInfo: {
        amountFull: '',
        amountDeduction: '',
        ruleUrl: 'https://material-page.yunshanmeicai.com/richText/1001099',
        category: '自营'
      }
    }
  },
  created() {
    // 获取优惠券信息，规则url
    API.marketResearch
      .getCouponInfo({
        deviceToken,
        companyId,
        cityId
      })
      .then(res => {
        this.couponInfo = res
      })
    // 获取任务列表
    API.marketResearch
      .getTodayTaskList({
        deviceToken,
        companyId,
        cityId
      })
      .then(res => {
        this.taskList = res
      })
  },
  methods: {
    goRecord() {
      this.$router.push({
        name: 'taskRecord'
      })
    }
  },
  onLogin() {
    window.location.reload()
  }
}
</script>

<style lang="scss" scoped>
.content {
  position: absolute;
  display: flex;
  width: 7.5rem;
  height: calc(100vh - 3.66rem);
  flex-direction: column;
  background-color: #fff;
  margin-top: -0.38rem;
  border-radius: 0.4rem 0.4rem 0 0;
  .title {
    // position: absolute;
    // z-index: 99999;
    // width: 100%;
    // height: 0.4rem;
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.14rem;
    .title-text {
      font-size: 0.4rem;
      color: #262626;
      font-weight: 600;
      margin: 0.38rem 0 0 0.32rem;
    }
    .title-btn {
      font-weight: 500;
      font-size: 0.28rem;
      color: #595959;
      margin: 0.42rem 0.32rem 0 0;
    }
  }
  .task-list {
    flex: 1;
    overflow-y: auto;
  }
  .empty {
    margin-top: 1rem;
  }
}
</style>
